/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface WeightItemDto
 */
export interface WeightItemDto {

    /**
     * @type {string}
     * @memberof WeightItemDto
     */
    type: WeightItemDtoTypeEnum;

    /**
     * @type {number}
     * @memberof WeightItemDto
     */
    bias: number;

    /**
     * @type {number}
     * @memberof WeightItemDto
     */
    factor: number;
}

/**
 * @export
 * @enum {string}
 */
export enum WeightItemDtoTypeEnum {
    HEAD = 'HEAD',
    NECK = 'NECK',
    SPINE = 'SPINE',
    LOWERLEFTARM = 'LOWER_LEFT_ARM',
    LOWERRIGHTARM = 'LOWER_RIGHT_ARM',
    UPPERLEFTARM = 'UPPER_LEFT_ARM',
    UPPERRIGHTARM = 'UPPER_RIGHT_ARM',
    LOWERLEFTLEG = 'LOWER_LEFT_LEG',
    LOWERRIGHTLEG = 'LOWER_RIGHT_LEG',
    UPPERLEFTLEG = 'UPPER_LEFT_LEG',
    UPPERRIGHTLEG = 'UPPER_RIGHT_LEG',
    LEFTFOOT = 'LEFT_FOOT',
    RIGHTFOOT = 'RIGHT_FOOT'
}

